import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.value === true)?_c('div',{staticClass:"flex"},[_c(VIcon,{staticClass:"mr-2",attrs:{"size":"20","color":"red"}},[_vm._v(" mdi-alert ")]),_c('span',{staticStyle:{"color":"red"}},[_vm._v("Wygeneruj ponownie")])],1):_c('div',[_c(VIcon,{staticClass:"mr-2",attrs:{"size":"20","color":"green"}},[_vm._v(" mdi-check-circle ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }